import React, { useState, useEffect, useCallback } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/solid';
import { Link } from "react-router-dom";

const Carousel = ({ events}) => {
    const [currentEventIndex, setCurrentEventIndex] = useState(0);

    const goToNextEvent = () => {
        const nextIndex = (currentEventIndex + 1) % events[0].length;
        setCurrentEventIndex(nextIndex);
    };

    const goToPreviousEvent = () => {
        const previousIndex = (currentEventIndex - 1 + events[0].length) % events[0].length;
        setCurrentEventIndex(previousIndex);
    };

    return (
        <div className="bg-background">
            <div className="mx-auto w-screen h-99 pt-4 flex-shrink-0 sm:px-6 lg:px-8">
                <div className="relative flex">
                    <img
                    src={events[0][currentEventIndex].image}
                    alt={events[0][currentEventIndex].title}
                    className="absolute top-0 left-0 w-full h-full cursor-pointer"
                    />
                    <ChevronLeftIcon
                        color="white"
                        width={40}
                        height={40}
                        className="absolute top-1/2 left-4 transform -translate-y-1/2 cursor-pointer"
                        style={{ zIndex: 10 }}
                        onClick={goToPreviousEvent}
                    />
                    <ChevronRightIcon
                        color="white"
                        width={40}
                        height={40}
                        className="absolute top-1/2 right-4 transform -translate-y-1/2 cursor-pointer"
                        style={{ zIndex: 10 }}
                        onClick={goToNextEvent}
                    />
                    <div className="relative mb-3 flex w-full flex-col items-start justify-end bg-black bg-opacity-40 p-8 sm:p-12">
                        <div className="mt-40 pt-40">
                            <h2 className="text-4xl font-title font-bold text-white">{events[0][currentEventIndex].title}</h2>
                            <p className="mt-2 mb-4 text-base font-text text-white">
                                {events[0][currentEventIndex].date} | {events[0][currentEventIndex].location}
                            </p>
                            <Link
                                to='/purchase'
                                className="mt-4 rounded-md bg-blue px-4 py-2.5 text-sm font-text text-white"
                                onClick={() => {
                                    window.scroll(0, 0);
                                  }}
                            >
                                Purchase Tickets {events[0][currentEventIndex].price} $
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Carousel;
